export const selectFaq = state => state.faq;
